import { createAsyncThunk } from '@reduxjs/toolkit';

import { ProjectsService } from 'api';

export const getPrimaryMarketItem = createAsyncThunk(
	'primaryMarket/getPrimaryMarketItem',
	async (id: string) => {
		return await ProjectsService.getOne(id);
	},
);
